module.exports = __webpack_public_path__ + "img/faca372.jpeg";